import React from 'react';
import styled from 'styled-components';

export const Select = ({
	error,
	label,
	name,
	onChange,
	onClick,
	keyValue,
	values,
	// selected,
	$inputSize,
	disabled
}: SelectProps & ContainerProps): JSX.Element => {
	return (
		<Container $inputSize={$inputSize} key={keyValue}>
			{label && <Label>{label}</Label>}
			<StyledSelect
				name={name}
				onChange={onChange}
				onClick={onClick}
				disabled={disabled}
				value={keyValue}
				keyValue={keyValue}
			>
				{!keyValue && <option selected>Choose...</option>}
				{values &&
					values.map((value, idx) => (
						<option
							key={idx}
							defaultValue={value}
							// selected={selected == value ? true : false}
						>
							{value}
						</option>
					))}
			</StyledSelect>
			{error && <ErrorDiv>{error}</ErrorDiv>}
		</Container>
	);
};

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
	error?: string | null;
	label?: string;
	name?: string;
	onChange?: (e: any) => void;
	onClick?: (e: any) => void;
	keyValue: string | number;
	values?: any[];
	selected?: string | number;
	placeholder?: string;
}

const Container = styled.div<ContainerProps>`
	width: ${props =>
		props.$inputSize === 'twoThird'
			? '66%'
			: props.$inputSize === 'third'
				? '33%'
				: props.$inputSize === 'half'
					? '50%'
					: props.$inputSize === 'full'
						? '100%'
						: '100%'};
	color: #575757;
	font-weight: bold;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
`;
interface ContainerProps {
	$inputSize?: string | undefined;
}

const Label = styled.label`
	font-size: 18px;
	margin-bottom: 12px;
`;

const StyledSelect = styled.select<SelectProps>`
	width: 100%;
	height: 100%;
	padding: 8px;
	background: transparent;
	height: 40px;
	border-color: lightgray;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);
	border-style: solid;
	border-radius: 5px;
	border-width: 1px;
	font-weight: bold;
	// color adjusted
	color: #575757;
	justify-self: left;

	& :focus {
		outline: none !important;
		border: 1px solid #f47920;
		color: #f47920;
	}
`;

const ErrorDiv = styled.div`
	margin-top: 8px;
	color: #db2828 !important;
	font-weight: bold;
	font-size: 90%;
	line-height: 125%;
	margin-bottom: 0;
`;
